export default __webpack_public_path__ + "static/media/third-party-data-consent-en-2.002988c7.jpg";